<template>
  <div class="shadow">
    <img class="arrow" src="../../assets/images/new-login-2018/arrow@2x.png">
    <div class="tip">
      <div class="h20">
        <img src="../../assets/images/new-login-2018/one@2x.png">
        <span>{{ text1 }}</span>
        <img src="../../assets/images/new-login-2018/select@2x.png">
        <span>{{ text2 }}</span>
      </div>
      <div class="h20 mt10">
        <img src="../../assets/images/new-login-2018/two@2x.png">
        <span>{{ text3 }}</span>
        <img src="../../assets/images/new-login-2018/Browser@2x.png">
        <span>{{ text4 }}</span>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
  import translate from '../common/Translate.js'
  export default {
    data () {
      return {
        text1: translate('Tap'),
        text2: translate('icon in the top right corner'),
        text3: translate('Click'),
        text4: translate('open in browser')
      }
    }
  }
</script>

<style type="text/css" lang="scss" scoped>
  .shadow {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: 0.7;
    background: #000000;
    z-index: 10;
    color: #ffffff;
    .arrow {
      width: 44px;
      float: right;
      margin: 5px 20px 0 0;
    }
    .tip {
      float: right;
      margin-top: 35px;
      img {
        width: 18px;
        height: 18px;
        float: left;
        margin: 0 5px;
      }
    }
    span {
      float: left;
    }
    .h20 {
      height: 20px;
    }
    .mt10 {
      margin-top: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// Shadow.vue?2f777497